import { TrendingUp } from "lucide-react";

const Vision = () => {
  return (
    <section id="vision" className="py-16">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-lg text-muted-foreground leading-relaxed max-w-4xl mx-auto">
            Making homeownership possible without the traditional 20% down payment with no PMI and no additional debt — 
            while creating a new asset class that opens real estate participation to investors.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center space-y-4">
            <div className="text-3xl">🔓</div>
            <h3 className="text-xl font-semibold text-foreground">Unlock access</h3>
            <p className="text-muted-foreground">
              Help more qualified buyers become owners sooner — without needing the traditional 20% down payment 
              and without new debt.
            </p>
          </div>
          
          <div className="text-center space-y-4">
            <div className="text-3xl">🤝</div>
            <h3 className="text-xl font-semibold text-foreground">Open participation</h3>
            <p className="text-muted-foreground">
              Enable more investors to participate in residential wealth creation through a new, scalable asset class.
            </p>
          </div>
          
          <div className="text-center space-y-4">
            <div className="flex justify-center">
              <TrendingUp className="w-12 h-12 text-investor" />
            </div>
            <h3 className="text-xl font-semibold text-foreground">Create liquidity</h3>
            <p className="text-muted-foreground">
              Evolve home equity from locked and static to a responsible, tradeable market.
            </p>
          </div>
        </div>
        
        <div className="text-center mt-12">
          <p className="text-sm text-muted-foreground italic">
            This is a teaser; we purposely avoid mechanisms here. Details are shared under appropriate confidentiality.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Vision;